angular.module('TetherApp').controller('ExternalController', [
    '$mdDialog',
    '$anchorScroll',
    '$location',
    '$window',
    '$timeout',
    'externalService',
    function (
        $mdDialog,
        $anchorScroll,
        $location,
        $window,
        $timeout,
        externalService
    ) {

        let self = this;
        let redirectTo = '/experience/external';

        self.externalList = {};
        self.external = {};
        self.currentPage = 1;

        self.index = function (page) {
            self.currentPage = page;
            externalService.indexExternal(self.currentPage)
                .then(onIndex, onError);
        }

        let onIndex = function (data) {
            self.externalList = data.data;
        }

        //START: SHOW SERVICE FUNCTIONS
        self.show = function (data) {
            self.external = JSON.parse(data);
        };
        //END: SHOW SERVICE FUNCTIONS

        //START: STORE SERVICE FUNCTIONS
        self.store = function () {
            let tempExternal = self.external;

            externalService.storeExternal(tempExternal)
                .then(onStore, onError);
        };

        let onStore = function (data) {
            $window.location.href = '/' + self.client_eid + redirectTo;
        };
        //END: STORE SERVICE FUNCTIONS

        //START: UPDATE SERVICE FUNCTIONS
        self.update = function () {
            let tempExternal = self.external;

            externalService.updateExternal(tempExternal)
                .then(onUpdate, onError);
        };

        let onUpdate = function (data) {
            $window.location.href = '/' + self.client_eid + redirectTo;
        };
        //END: UPDATE SERVICE FUNCTIONS

        //START: DESTROY SERVICE FUNCTIONS
        self.delete = function (externalId) {
            if ($window.confirm(self.deleteText.replace(':id', externalId))) {
                externalService.deleteExternal(externalId)
                    .then(onDelete, onError);
            }
        };

        let onDelete = function (data) {
            window.location.reload();
        };
        //END: DESTROY SERVICE FUNCTIONS

        //START: GENERAL SERVICE FUNCTIONS
        let onError = function (data) {
            $location.hash('top');
            $anchorScroll();
            self.errors = data.data.errors;
        };
        //END: GENERAL SERVICE FUNCTIONS
    }
]);
